import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, staggerContainer, staggerItem } from './ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
const forYou = ['Eres mamá soltera o te sientes sola aunque no lo estés', 'No tienes red de apoyo y cargas con todo', 'Eres inmigrante y extrañas tener a alguien cerca', 'Tu mente siempre está en mil cosas — nunca en paz', 'Te han invalidado toda la vida y ya no sabes ni qué creer', 'Amas a tus hijos pero a veces no encuentras paz ni para ti', 'La fe es parte de ti y quieres una solución que no ignore eso'];
const notForYou = ['Buscas una solución mágica sin hacer nada', 'No estás dispuesta a dedicar 10 minutos al día a ti misma', 'Quieres perfección — aquí ofrecemos progreso real'];
export function TargetAudience() {
  return <section className="py-24 bg-cream-alt" data-id="element-175">
      <div className="max-w-5xl mx-auto px-6 md:px-8" data-id="element-176">
        <FadeIn className="text-center mb-16" data-id="element-177">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-brown" data-id="element-178">
            ¿Para Quién Es Esto?
          </h2>
          <div className="w-16 h-1 bg-sage mx-auto rounded-full opacity-50" data-id="element-179" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-180">
          {/* Para ti */}
          <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: '-100px'
        }} className="space-y-6" data-id="element-181">
            <h3 className="text-2xl font-bold text-sage mb-6 flex items-center gap-2" data-id="element-182">
              ✅ Esto es para ti si:
            </h3>
            {forYou.map((text, index) => <motion.div key={index} variants={staggerItem} className="flex items-start gap-4 p-5 bg-cream rounded-2xl shadow-sm border border-sage/20" data-id="element-183">
                <div className="flex-shrink-0 text-sage mt-1" data-id="element-184">
                  <CheckCircle2 size={24} data-id="element-185" />
                </div>
                <p className="text-lg text-brown-light leading-relaxed" data-id="element-186">
                  {text}
                </p>
              </motion.div>)}
          </motion.div>

          {/* NO es para ti */}
          <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: '-100px'
        }} className="space-y-6" data-id="element-187">
            <h3 className="text-2xl font-bold text-red-400 mb-6 flex items-center gap-2" data-id="element-188">
              ❌ Esto NO es para ti si:
            </h3>
            {notForYou.map((text, index) => <motion.div key={index} variants={staggerItem} className="flex items-start gap-4 p-5 bg-cream rounded-2xl shadow-sm border border-red-200" data-id="element-189">
                <div className="flex-shrink-0 text-red-400 mt-1" data-id="element-190">
                  <XCircle size={24} data-id="element-191" />
                </div>
                <p className="text-lg text-brown-light leading-relaxed" data-id="element-192">
                  {text}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}